<template>
  <v-container>
    <v-btn fixed dark fab bottom right color="pink" @click="createNew">
      <v-icon>mdi-plus</v-icon>
    </v-btn>
    <v-data-table :items="houses" :headers="headers" :loading="isBusy" @click:row="editSelected"
                  hide-default-footer disable-sort fixed-header >
      <template v-slot:item.info="{ item }">
        {{ item.city }}, {{ item.street }}, дом {{ item.number }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
export default {
  name: 'Houses',
  data() {
    return {
      isBusy: false,
      headers: [
        {value: 'info', text: 'Адрес дома'},
        {value: 'email', text: 'e-mail', sortable: false},
        {value: 'reminderDay', text: 'День', sortable: false},
      ],
      houses: []
    }
  },
  mounted() {
    this.isBusy = true
    this.$http("/house")
        .then(resp => this.houses = resp.data)
        .finally(() => this.isBusy = false)
  },
  methods: {
    createNew: function () {
      console.log("createNew ")
      this.$router.push({name: 'HouseEdit', params: {houseId: null}})
    },
    editSelected: function (item) {
      console.log("onClickRow ", item)
      this.$router.push({name: 'HouseEdit', params: {houseId: item.id}})
    }
  }
}

</script>

<style lang="css" scoped>
>>> tbody tr :hover {
  cursor: pointer;
}
</style>